import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";
import AllAdminRow from "../AllAdminUsers/AllAdminRow/AllAdminRow";
import ViewReplies from "./ViewReplies";
import "./ViewInquiry.css";
import noRecords from '../../../assets/img/norecord.png';
import ShowMoreText from "react-show-more-text";
import InquiryReply from "../InquiryReply/InquiryReply";
import InquiryReplyInModel from "../InquiryReply/InquiryReplyInModel/InquiryReplyInModel";
import ReactGA from "react-ga";

class ViewInquiry extends Component {

    constructor(props) {
        super(props);


        this.state = {
            show: false,
            name: this.props.inquiryData.name,
            email: this.props.inquiryData.email,
            // subject: this.props.inquiryData.subject,
            subject: '',
            inquiry: this.props.inquiryData.message,
            createdOn: this.props.inquiryData.createdDate,
            replies: [],
            repliedByAdminName: "",
            repliedAdminId: "",
            reply: ""

        };

        this.handleShow = this.handleShow.bind(this);
        this.handleCloseAll = this.handleCloseAll.bind(this);
        this.addSubject = this.addSubject.bind(this);


    }


    addSubject = () =>{
        if(this.props.inquiryData.subject==="QUOTATION_RELATED"){
            this.setState({
                subject: "お見積りに関するご質問",

            })
        }else if(this.props.inquiryData.subject==="PRODUCTION_RELATED"){
            this.setState({
                subject: "製造基準・技術的に関するご質問",

            })
        }else if(this.props.inquiryData.subject==="PRICING_RELATED"){
            this.setState({
                subject: "ご注文やサービスご利用に関するご質問",

            })
        }else if(this.props.inquiryData.subject==="PAYMENT_RELATED"){
            this.setState({
                subject: "お支払いに関するご質問",

            })
        }else if(this.props.inquiryData.subject==="QUALITY_RELATED"){
            this.setState({
                subject: "出荷に関するご質問",

            })
        }else if(this.props.inquiryData.subject==="OTHER"){
            this.setState({
                subject: "その他",

            })
        }else if(this.props.inquiryData.subject==="REQUEST"){
            this.setState({
                subject: "無料基板サンプル請求",

            })
        }
    }
    handleCloseAll = () => {
        this.setState({
            show: false,

        });
        this.props.getAll(0,10)
    };

    handleShow = () => {
        this.setState({
            show: true,
        });

    };

    getReply() {
        axios.get(RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiryData.id + '/viewReply')
            .then((res) => {
                // console.log(res.data);
                this.setState({
                    replies: res.data.inquiries

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }

    componentDidMount() {
        this.getReply();
        this.addSubject();
    }

    render() {
        return (
            <span>
                <a className="btn btn-xs btn-success" onClick={this.handleShow}>
                     <FormattedMessage id="app.admin-inquiry-row.view"
                                       defaultMessage="View"
                                       description=""/>

                </a>

                <Modal show={this.state.show} onHide={this.handleCloseAll} dialogClassName="view-inquiry-modal">
                    <form onSubmit={this.onSubmit}>
                        <Modal.Header closeButton>
                            <div className="title-1 color-text">
                                <FormattedMessage id="app.admin-inquiry-view.title"
                                                  defaultMessage="View Inquiry"
                                                  description=""/>

                            </div>
                        </Modal.Header>
                        <Modal.Body>
                             <div className="row color-text">
                                 <div className="inquiry-reply-row-margin">
                                     <div className="col-md-3">
                                        <b> <FormattedMessage id="app.admin-inquiry-view.date"
                                                           defaultMessage="Inquiry Date"
                                                           description=""/></b>
                                    </div>
                                    <div className="col-md-9 no-padding-left text-left modals-responsive-padding-left">
                                        {this.state.createdOn.substring(0, 4)} 年 {this.state.createdOn.substring(5, 7)} 月
                                        {this.state.createdOn.substring(8, 10)} 日&nbsp;&nbsp;{this.state.createdOn.substring(11, 16)}
                                    </div>
                                    </div>
                            </div>

                            <div className="row color-text">
                                 <div className="inquiry-reply-row-margin">
                                     <div className="col-md-3">
                                       <b><FormattedMessage id="app.admin-inquiry-view.name"
                                                         defaultMessage="Name"
                                                            description=""/></b>
                                    </div>
                                    <div className="col-md-9 no-padding-left text-left modals-responsive-padding-left">
                                        {this.state.name}
                                    </div>
                                 </div>
                            </div>

                             <div className="row color-text">
                                 <div className="inquiry-reply-row-margin">
                                     <div className="col-md-3">
                                       <b><FormattedMessage id="app.admin-inquiry-view.email"
                                                         defaultMessage="Email"
                                                            description=""/></b>
                                    </div>
                                    <div className="col-md-9 no-padding-left text-left modals-responsive-padding-left">
                                        {/*<input type="text"
                                               className="form-control input-sm"
                                               name="subject"
                                               disabled={true}
                                               value={this.state.email}
                                        />*/}
                                        {this.state.email}
                                    </div>
                                    </div>
                            </div>
                            <div className="row color-text">
                                 <div className="inquiry-reply-row-margin">
                                     <div className="col-md-3">
                                       <b>件名</b>
                                    </div>
                                    <div className="col-md-9 no-padding-left text-left modals-responsive-padding-left">
                                        {/*<input type="text"
                                               className="form-control input-sm"
                                               name="subject"
                                               disabled={true}
                                               value={this.state.subject}
                                        />*/}
                                        {this.state.subject}
                                    </div>
                                    </div>
                            </div>
                        <div className="row color-text">
                            <div className="inquiry-reply-row-margin">
                                <div className="col-md-3 ">
                                   <b> <FormattedMessage id="app.inquiry-reply.inquiry"
                                                      defaultMessage="Inquiry"
                                                         description=""/></b>
                                </div>
                                <div className="col-md-9 no-padding-left modals-responsive-padding-left">
                                    {/*<textarea type="text"
                                              className="form-control"
                                              name="inquiry"
                                              disabled={true}
                                              value={this.state.inquiry}
                                    />*/}
                                    <ShowMoreText
                                        lines={2}
                                        more='...詳細'
                                        less='...閉じる'
                                        anchorClass=''
                                    >
                                    {this.state.inquiry}
                                    </ShowMoreText>
                                </div>
                            </div>
                        </div>
                            <hr/>
                            <div className="row color-text">
                            <div className="inquiry-reply-row-margin">
                                <div className="col-md-4">
                                    <div className="text-left modals-responsive-padding-left resp-padding-modal">
                                        <h4>
                                            <FormattedMessage id="app.inquiry-view.replies"
                                                              defaultMessage="Replies"
                                                              description=""/>

                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                            <div className="row"></div>
                            {/*{this.state.replies.length === 0 &&
                            <div className="color-text text-align-center">

                                <h5>このお問い合わせに関しまして管理チームの方で対応中です。しばらくお待ちください。</h5>
                            </div>

                            }*/}

                            {this.state.replies.map(replyData => {
                                return <ViewReplies replyData={replyData} inquiry={this.props.inquiryData}/>;

                            })}


                            <span className="modals-responsive-margin-left">
                               <InquiryReplyInModel
                                             userData={this.props.userData}
                                             authenticate={this.props.authenticate}
                                             authenticated={this.props.authenticated}
                                             userId={this.props.userId}
                                             inquiryId = {this.props.inquiryData.id}
                                             handleCloseAll = {this.handleCloseAll}
                                             getAll = {this.props.getAll}
                               />

                            </span>





                        </Modal.Body>
                        {/*<Modal.Footer>
                            <div className="view-inquiry-div">
                                <a className="btn btn-default bottom-button" onClick={this.handleCloseAll}>
                                   <FormattedMessage id="app.inquiry-view.replies.close"
                                                     defaultMessage="Close"
                                                     description=""/>
                                </a>
                            </div>
                        </Modal.Footer>*/}
                    </form>
                </Modal>
            </span>
        )
    }

}

export default ViewInquiry;



// WEBPACK FOOTER //
// ./src/components/Admin/VIewInquiry/ViewInquiry.js